import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { APP_NAME } from '../../../constants/constants.js';

const PrivateRoute = ({ login, token, fetchUser, fail, query, component: Component }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if ((!token && !login) || (fail && token && !login)) {
        localStorage.setItem(`url-${APP_NAME}`, window.location.href);
        return <Navigate to="/login" />;
    }

    if (fail || !token) {
        window.location.reload();
        return null;
    }

    if (!login) {
        fetchUser({ query });
        return null;
    }

    return <Component />;
};

export default PrivateRoute;